<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmSearch"
           title="PESQUISA DE DESPESAS DIVERSOS"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClear"
           v-on:Search="onClickSearch"
           v-on:New="onNew">
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxInsure">Situação:</label>
          <div class="input-group">
            <b-form-select v-model="form.situacao.value" :options="form.situacao.options" >
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="0">EM ELABORAÇÃO</option>
                <optgroup label="FLUXO DE APROVAÇÃO">
                  <option :value="1">AGUARDANDO APROVAÇÃO MESTRE/ENGENHEIRO RESPONSÁVEL</option>
                  <option :value="2">AGUARDANDO APROVAÇÃO RESPONSÁVEL REGIONAL</option>
                  <option :value="3">AGUARDANDO APROVAÇÃO CONTROLADORIA</option>
                  <option :value="4">DESPESA APROVADA</option>
                  <option :value="5">PAGAMENTO REALIZADO</option>
                </optgroup>
                <optgroup label="REPROVAÇÃO">
                  <option :value="-1">REPROVADO PELO MESTRE/ENGENHEIRO RESPONSÁVEL</option>
                  <option :value="-2">REPROVADO PELO RESPONSÁVEL REGIONAL</option>
                  <option :value="-3">REPROVADO PELO CONTROLADORIA</option>
                </optgroup>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsure">Obra:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          placeholder="Digite o nome da Obra"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.referencia"
                          :debounceLength="2"
                          :formField="form.obraID"
                          v-on:search="onSearchObra"
                          v-on:changeCode="onChangeCodeObra"/>
        </div>
        <div class="col-md-4">
          <label for="txtInsured"> Responsável:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          placeholder="Digite o nome do Responsável"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="form.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="cbxInsure">Regional:</label>
          <div class="input-group">
            <b-form-input type="text"
                          class="col-2 text-upper"
                          style="height: calc(2.09375rem + 2px);"
                          :placeholder="'Código'"
                          v-model="form.secaoRH.value"
                          :size="form.secaoRH.maxlength"
                          :state="form.secaoRH.state"
                          @focus="onClearSection"
                          v-on:change="onChangeCodeSection"
            />&nbsp;
            <b-form-select v-model="form.secaoRHID.value"
                           :options="form.secaoRHID.options" >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtCodePeople"><small v-show="form.dataInicioSolicitacao.required" class="text-danger">*</small>Inicio Solicitação:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtDataInicioSolicitacao"
                          ref="dataInicioSolicitacaoComp"
                          v-model="form.dataInicioSolicitacao.value"
                          :required="form.dataInicioSolicitacao.required"
                          :state="form.dataInicioSolicitacao.state" />
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtCodePeople"><small v-show="form.dataFimSolicitacao.required" class="text-danger">*</small>Fim Solicitação:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtDataFimSolicitacao"
                          ref="dataFimSolicitacaoComp"
                          v-model="form.dataFimSolicitacao.value"
                          :required="form.dataFimSolicitacao.required"
                          :state="form.dataFimSolicitacao.state" />
          </div>
        </div>
      </div>
      <template v-slot:FooterButtonLeft>
        <button type="button" class="btn btn-third btn-sm d-none" @click="onNew"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"><i class="fas fa-plus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.New}}</span></button>
      </template>
    </Forms>
    <Tables ref="tableGrid"
            :columns="[
              '',
              'Folha',
              'Dt. Solicitação',
              'Solicitante',
              'Favorecido',
              'Responsável',
              'Regional',
              'Obra',
              'Situação',
              'Valor',
              'Ações'
            ]"
            :showFullscreen="true"
            :messageTipFooter="$lang.Common.ClickToSelect"
            :showPrint="true"
            :showDownload="false"
            v-on:Load="onSearch"
            v-on:Fullscreen="onFullscreen"
            v-on:SaveFile="onDownload"
            v-on:Print="onPrint">
      <tr v-for="(obj, index) in this.objList" v-bind:key="index">
        <TableColumn :IsCustom="true" :status="obj.status">
          <b-form-checkbox :id="`cbxQuadro-${index}`"
                           v-model="obj.checked"
                           :name="`cbxQuadro-${index}`"
                           :value="true"
                           size="sm" />
        </TableColumn>
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.folha ? FormatFolha(obj.folha) : ''" />
        <TableColumn :IsDatetime="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.dataCriacao" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.nomeContaAcao" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.favorecido ? obj.favorecido.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.secaoRH.nome" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.obraRH ? obj.obraRH.nome : ''" />
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <span v-if="obj.situacao === null || obj.situacao === 0" class="badge badge-default badge-pd text-toupper">EM ELABORAÇÃO</span>
          <span v-else-if="obj.situacao === 1" class="badge badge-wait text-toupper">AGUARDANDO APROVAÇÃO <br>MESTRE/ENGENHEIRO RESPONSÁVEL</span>
          <span v-else-if="obj.situacao === 2" class="badge badge-wait text-toupper">AGUARDANDO APROVACAO <br>COORDENADOR REGIONAL</span>
          <span v-else-if="obj.situacao === 3" class="badge badge-success badge-pd text-toupper">AGUARDANDO APROVACAO <br>CONTROLADORIA</span>
          <span v-else-if="obj.situacao === 4" class="badge badge-success badge-pd text-toupper">APROVADO</span>
          <span v-else-if="obj.situacao === 5" class="badge badge-success badge-pd text-toupper">PAGAMENTO REALIZADO</span>
          <span v-else-if="obj.situacao === -1" class="badge badge-danger badge-pd-disapproval text-toupper">REPROVADO <br>MESTRE/ENGENHEIRO RESPONSÁVEL</span>
          <span v-else-if="obj.situacao === -2" class="badge badge-danger badge-pd-disapproval text-toupper">REPROVADO <br>COORDENADOR REGIONAL</span>
          <span v-else-if="obj.situacao === -3" class="badge badge-danger badge-pd-disapproval text-toupper">REPROVADO <br>CONTROLADORIA</span>
        </TableColumn>
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <strong v-if="obj.valorTotal >= 0" style="color: #004987">{{formatMoney(obj.valorTotal)}}</strong>
          <strong v-else class="text-danger">{{formatMoney(obj.valorTotal)}}</strong>
        </TableColumn>
        <TableColumn :IsActionsButtons="true" :HasChange="false" :HasDelete="obj.situacao === null || obj.situacao === 0" v-on:Delete="onDeleteBoard(obj)" />
      </tr>
    </Tables>
  </div>
</template>

<script>
import EmployeeBoardSearch from './search.js'
export default EmployeeBoardSearch
</script>

<style scoped>
.custom-group-addon {
  padding: 0.4rem 1rem;
  display: block;
  position: absolute;
  z-index: 9;
  cursor: pointer;
}
.badge-pd {
  padding: 5px 5px 3px 5px;
  color: #000;
}
.badge-pd-disapproval {
  padding: 5px 5px 3px 5px;
}
.badge-wait {
  background-color: #ffc107;
  color: #000;
  padding: 5px 5px 3px 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/search/search.vue